import script from "./SearchHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SearchHeader.vue?vue&type=style&index=0&id=69eeedf2&lang=css"

const __exports__ = script;

export default __exports__